import { OurNode } from "@src/cloud-connect/poc/our-node";
import { Criteria } from "./criteria";

export const AlarmTypeValue = {
  COMPUTED: "computed",
  SENSOR: "sensor",
} as const;

export type AlarmType = (typeof AlarmTypeValue)[keyof typeof AlarmTypeValue];

export class Alarm {
  private our_node: OurNode;
  private criteria: Criteria;
  private active: boolean;
  private type: AlarmType;
  private data_type: string;
  observers: Set<() => void> = new Set();

  constructor(
    our_node: OurNode,
    criteria: Criteria,
    active: boolean,
    type: AlarmType,
    data_type: string,
  ) {
    this.setOurNode(our_node);
    this.setCriteria(criteria);
    this.setActive(active);
    this.setType(type);
    this.setDataType(data_type);
  }

  getOurNode() {
    return this.our_node;
  }

  getCriteria() {
    return this.criteria;
  }

  getActive() {
    return this.active;
  }

  getComputed() {
    return this.type === AlarmTypeValue.COMPUTED;
  }

  getType() {
    return this.type;
  }

  getDataType() {
    return this.data_type;
  }

  setOurNode(our_node: OurNode) {
    this.our_node = our_node;
  }

  setCriteria(criteria: Criteria) {
    this.criteria = criteria;
  }

  setActive(active: boolean) {
    this.active = active;
    this.notifyObservers();
  }

  setType(type: AlarmType) {
    this.type = type;
  }

  setDataType(data_type: string) {
    this.data_type = data_type;
  }

  toJSON() {
    const getDisplayName = (our_node: OurNode) => {
      let value = "";

      if (
        our_node &&
        our_node.attributes &&
        our_node.attributes.unit &&
        our_node.attributes.unit.display_name
      ) {
        value = our_node.attributes.unit.display_name;
      }

      return value;
    };

    return {
      node: {
        id: this.our_node.id,
        name: this.our_node.name,
        unit: getDisplayName(this.our_node),
        type: this.type,
      },
      criteria: this.criteria.toJSON(),
      active: this.active,
      /* data_type: this.data_type, */ // not needed in the body
    };
  }

  addObserver(observer: () => void) {
    this.observers.add(observer);
  }

  removeObserver(observer: () => void) {
    this.observers.delete(observer);
  }

  notifyObservers() {
    this.observers.forEach((observer) => observer());
  }
}
